<!-- <img [src]="imageUrl" class="img app-image rounded" /> -->
<video *ngIf="videoUrl" width="350" controls>
    <source [src]="videoUrl"  type="video/mp4">>
    Your browser does not support the video tag.
  </video>
  
<input type="file" accept="video/*" #file (change)="handleFileInput($event.target.files)">
<div *ngIf="error" class="app-text-danger my-2">{{error}}</div>
<button type="button" [ngClass]="{'disabled-div' : isEditMode}" (click)="file.click()" class="app-btn outline medium my-2"><i class="fa fa-picture-o" aria-hidden="true"></i>&nbsp;<span *ngIf="videoUrl">Change Video</span><span *ngIf="!videoUrl">Upload Video</span></button>